// extracted by css-extract-rspack-plugin
export default {"qrRow":"FooterQRRowChina-module__qrRow","qrTile":"FooterQRRowChina-module__qrTile","qrImage":"FooterQRRowChina-module__qrImage","qrLabel":"FooterQRRowChina-module__qrLabel"};